import CImage from './Image.vue'

export { CImage }
export default { CImage }
